import '../tables/Table.module.css'
import classes from '../tables/Table.module.css'
function InteractiveValidationTable(props) {
    
            
    let tableHead = (
        <>
            <tr style={{fontSize: '14px'}}>
                {props.colNames.map((columnName, index) => (<th key={index} >{columnName}</th>))}
            </tr>
        </>);
    let tableRows = (<></>)
    if(props.selection_options){
        let select_style = classes.selectValidation;
        let selectionOptions = props.selection_options;
        let default_selection = 'select available response';
        if (props.selection_options[0] === 'no response available'){
            default_selection = 'no response(s) available';
            selectionOptions = [];
            select_style = classes.selectValidation2;
        }
        tableRows = props.tableRows.map((row, rowIndex) => (
            <tr key={`row_${rowIndex}`}>
                {Object.keys(row).map((key) => {
                    if (key === 'valid') {
                        // skipp
                    } 
                    else if (key === 'prev_name' && row['valid']===false) {
                        return(
                            <td className={classes.paginated} key={`${key}_${rowIndex}`} style={{color:'red', fontSize: '14px'}}>
                                        {row[key]}
                            </td>);
                    }
                    else if (key === 'prev_name' || row['valid']===true) {
                        return(
                            <td className={classes.paginated} style={{fontSize: '14px'}} key={`${key}_${rowIndex}`}>
                                        {row[key]}
                            </td>);
                    }
                    else {
                        return (
                            <td key={`${key}_${rowIndex}`} style={{display:'flex'}}>
                                <div className={classes.triangle_right}></div>
                                <select name='gonogo'
                                    className={select_style}
                                    id={`${key}_${rowIndex}`} 
                                    onChange={props.inputHandler}>
                                    <option value='' disabled selected>{default_selection}</option>
                                    {selectionOptions.map((option, index) => (
                                        <option key={index} value={option}>
                                        {option}
                                        </option>
                                     ))}
                                </select>
                            </td>
                        );
                    }
                })}
            </tr>
        ));
    }

    else{
        tableRows = props.tableRows.map((row, rowIndex) => (
            <tr key={`row_${rowIndex}`}>
                {Object.keys(row).map((key) => {
                    if (key === 'valid') {
                        // skipp
                    } 
                    else if (key === 'noPin') {
                        // skipp
                    } 
                    else if (key === 'prev_name' && row['valid']===false) {
                        return(
                            <td className={classes.paginated} key={`${key}_${rowIndex}`} style={{color:'red', fontSize: '14px'}}>
                                        {row[key]}
                            </td>);
                    }
                    else if (key === 'prev_name' || row['valid']===true) {
                        return(
                            <td className={classes.paginated} style={{fontSize: '14px'}} key={`${key}_${rowIndex}`}>
                                        {row[key]}
                            </td>);
                    }
                    else if (key === 'new_name' && row['noPin']===true) {
                        return(
                            <td className={classes.paginated} style={{fontSize: '14px'}} key={`${key}_${rowIndex}`}>
                                <button 
                                    id={`${key}_${rowIndex}`} 
                                    // className={'actionButtonTiny'}
                                    className={'cellButton'}
                                    style={{marginTop:'3px', marginBottom:'3px', width:'100px'}}
                                    onClick={props.onEdit}>
                                    {row[key]}
                                </button>
                            </td>);
                    }
                    else {
                        return (
                            <td key={`${key}_${rowIndex}`} style={{display:'flex'}}>
                                <div className={classes.triangle_right}></div><input
                                    className={classes.inputValidation}
                                    id={`${key}_${rowIndex}`} 
                                    onChange={props.inputHandler} 
                                    type='text' 
                                    placeholder={props.placeholder} 
                                    autoComplete='false' 
                                    value={row[key]} 
                                    style={{fontSize: '14px'}}
                                />
                            </td>
                        );
                    }
                })}
            </tr>
        ));
    }


    return(<>
        <table >
            <thead >
                {tableHead}
            </thead>
            <tr><div style={{height: '4px'}} colSpan={props.colNames.length}></div></tr>
            <tbody style={{border: '0.5px solid var(--aixelo-gray-light)'}}>
                {tableRows}
            </tbody>
        </table>
    </>
    );

}


export default InteractiveValidationTable;
